import { render, staticRenderFns } from "./Drawerx.vue?vue&type=template&id=43ac2f06&scoped=true&"
import script from "./Drawerx.vue?vue&type=script&lang=js&"
export * from "./Drawerx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ac2f06",
  null
  
)

export default component.exports